import React, { useState } from 'react';
import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai';

export default function CustomInput({ disabled = false, label, placeholder, onChange, value, type, name, error, id }) {
  // define states
  const [showPassword, setShowPassword] = useState(false);

  // toggle password
  const handleTogglePassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="mt-1 w-full">
  {label && (
    <label
      htmlFor={id}
      className="block mb-1 text-xs md:text-sm font-medium text-gray-700"
    >
      {label}
    </label>
  )}

  <div className="relative w-full">
    <input
      id={id}
      name={name}
      type={showPassword ? "text" : type}
      value={value}
      placeholder={placeholder}
      onChange={onChange}
      disabled={disabled}
      className={`
        w-full
        rounded-md border border-gray-300
        bg-white
        px-3 py-2
        text-xs md:text-sm text-gray-800
        focus:outline-none
        focus:ring-2 focus:ring-sky-500
        focus:border-sky-500
        transition
        ${disabled ? "bg-gray-100 cursor-not-allowed text-gray-500" : ""}
        ${error ? "border-red-400 focus:ring-red-300" : ""}
      `}
    />

    {type === "password" && (
      <button
        type="button"
        onClick={handleTogglePassword}
        className="
          absolute inset-y-0 right-0
          flex items-center px-3
          text-gray-500
          hover:text-gray-700
          focus:outline-none
        "
      >
        {showPassword ? <AiOutlineEyeInvisible /> : <AiOutlineEye />}
      </button>
    )}
  </div>

  {error && (
    <span className="mt-1 block text-xs text-red-500">
      {error}
    </span>
  )}
</div>

  );
}
